import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-machine-detail',
  templateUrl: './machine-detail.component.html',
  styleUrls: ['./machine-detail.component.css']
})
export class MachineDetailComponent {
  machineName: string;
  instruments: any[];
  constructor(private route: ActivatedRoute,
    private dataService: DataService){
    route.params.subscribe(params => {
      this.machineName = params['name'];
      this.dataService.getInstrumentsByName(this.machineName).then(data => {
        this.instruments = data;
      });

    })
  }

}
